import "./utils/configs";
import { EventTarget } from "event-target-shim";

let uiRoot;
// Handles user-entered messages
export default class SyncNAFHelper extends EventTarget {
  constructor(hubChannel, events) {
    super();
    this.hubChannel = hubChannel;
    this.events = events;
    this.streamNetworkId = null;

    //TODO: Create specific channels for this in backend
    this.hubChannel?.channel.on("message", entry => {
      if (entry.type === "stream") {
        this.requestStream(entry);
      } else if (entry.type === "stream-sync") {
        this.syncStreamNAF(entry);
      }
    });

    events.on("hub:join", entry => {
      if (this.streamNetworkId) {
        setTimeout(() => {
          this.emitSyncStream({
            dataType: "u",
            clientId: NAF.connection.adapter?.session_id,
            networkId: this.streamNetworkId
          });
        }, 4000);
      }
    });
  }

  setNetworkId(networkId) {
    this.streamNetworkId = networkId;
  }

  emitSyncStream(data) {
    this.hubChannel.sendMessage(data, "stream");
  }

  requestStream(entry) {
    if (!NAF.entities.getEntity(entry.body.networkId)) {
      const data = {
        dataType: "u",
        data: entry.body,
        clientId: NAF.connection.adapter?.session_id,
        networkId: entry.body.networkId
      };
      this.hubChannel.sendMessage(data, "stream-sync");
    }
  }

  syncStreamNAF(entry) {
    const arr = NAF.connection.adapter.clientEntities;
    const element = this.findClientEntity(arr, entry.body.networkId, entry.body.clientId);
    let entity = NAF.entities.getEntity(entry.body.networkId);
    if (element && NAF.utils.isMine(entity)) {
      NAF.connection.adapter.sendDataGuaranteed(element.clientId, element.dataType, element.data);
    }
    NAF.connection.entities.updateEntity();
  }

  findClientEntity(arr, networkId, clientId) {
    return arr.find(item => item.data.networkId === networkId && item.clientId === clientId);
  }
}
